<template lang="html">
   <div class="upload-box" @dragover.prevent @drop.prevent>
      <div 
         class="upload-box-input" 
         :class="{'active': active}"
         @dragenter="active = true" 
         @dragleave="active = false" 
         @drop="onFileDropped"
      >
         <input 
            class="input-file" 
            type="file" 
            :accept="accept"
            :ref="name"
            :id="name"
            :multiple="multiple"
            @change="onInputChange"
         />

         <label :for="name" class="file-label">
            <div class="label">{{label}}</div>
            <div class="file-name" v-if="filesSelected" v-html="fileName"></div>
            <div clss="file-text" v-if="!filesSelected">
               <i class="fa fa-cloud-upload-alt"></i><strong>Choose a file</strong><span class="drag-drop"> or drag it here</span>.
            </div>
         </label>
      </div>
   </div>

</template>

<script>
export default {
   props: {
      name: {
         default: 'file'
      },
      label: {
         default: 'File'
      },
      accept: {
         default: '*'
      },
      multiple:{
         default: false
      },
   },
   data () {
      return {
         filesSelected: false,
         fileName: '',
         active: false
      }
   },
   methods: {
      updateSelf(model) {
         this.$emit("input", model);
      },
      onFileDropped(e){
         let files = e.dataTransfer.files;
         this.onFilesSelected(files)
      },
      onInputChange(e){
         let files = e.target.files
         this.onFilesSelected(files)
      },
      onFilesSelected(files){
         this.filesSelected = true
         this.active = false

         if(files.length <= 1){
            this.fileName = `<b>${files[0].name}</b> selected`
         }else{
            this.fileName = `<b>${files[0].name}</b> and <b>${(files.length - 1)}</b> other file(s)`
         }

         this.updateSelf(files)
         this.$emit('file-selected',{files,name: this.name})
      }
   },
}
</script>